import styled from 'styled-components';

import { flexAsRow } from '@components/Styled/mixins';
import { Bold } from '@components/Styled';

const Badge = styled.div`
  ${flexAsRow(1)};

  align-items: center;
  background-color: ${({ theme, $backgroundColor }) => (
    $backgroundColor ?? theme.colors.secondary.lighterBlue
  )};
  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(1)}`};
  border-radius: ${({ theme }) => theme.spacing(0.5)};

  > p {
    padding: 0;
  }
`;

const BadgeText = styled(Bold)`
  white-space: nowrap;
  color: ${({ $textColor }) => $textColor ?? 'inherit'};
`;

export { Badge, BadgeText };
